module.exports = __webpack_public_path__ + "img/step-2-2-en.3f94a846.png";